<div class="fixed-footer" *ngIf="footerText">
  {{ footerText }}
</div>
